import { ConsultarHomologacao } from "./ConsultarHomologacao";

export default ConsultarHomologacao;